import React, { useContext, useState } from 'react'
import { isMobile, isDesktop, isIpad } from '../../utils/ScreenSizeHelper'
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import GreetingUser from "../../utils/greetingUser"
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from "react-router-dom";

import CircularProgress from "@mui/material/CircularProgress";
import InsertChartIcon from '@mui/icons-material/InsertChart';
import { IconButton } from '@mui/material';
import { ClockIcon } from '@mui/x-date-pickers';
import ListProduct from '../../composed/products/ListProduct';
import Product from '../../composed/products/Product';
import ManageDrivers from '../../composed/managedeliveries/ManageDrivers';
import ManageDeliveries from '../../composed/managedeliveries/ManageDeliveries';
import { SignUpDataContext } from '../../context-api/data-provider/SignupDataProvider';
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';
import variables from "../../utils/assets/_variables.scss";
import AtomicButton from '../../atomic/button/Button';
import zIndex from '@mui/material/styles/zIndex';


const Dashboard = () => {
    const navigate = useNavigate();
    const [lastSelectedItem, setLastSelectedItem] = useState('dashboard');
    const { setLoginAPIResponse, onLogin, loginAPIResponse, onLogout } = useContext(SignUpDataContext);
    const { isLoggedIn, setisLoggedIn, onLoadInfoResponse, } = useContext(GlobalStateDataContext)

    const { KitchenInfo, kitchenOperationObject, managing_branch_name } = onLoadInfoResponse?.data?.data?.data || {}
    const RedirectToLogin = async () => navigate('/login')


    const handleItemSelectionToggle = (event, itemId, isSelected) => {
        if (isSelected) {
            setLastSelectedItem(itemId);
        }
    };

    const triggerLogout = async () => {
        await onLogout()
        RedirectToLogin()
        window.location.reload()
    }

    const TitleName = (lastSelectedItem) => {

        switch (lastSelectedItem) {
            case 'dashboard':
                return 'Dashboard';
            case 'settings':
                return 'Settings';
            case 'menu':
                return 'Menu';
            case 'manage drivers':
                return 'Manage drivers';
            case 'manage deliveries':
                return 'Manage Deliveries';
            case 'orders':
                return 'Order Management';

        }
    }



    return (
        <div style={{ display: 'flex' }}>
            <div style={{ position: 'fixed', left: 0, top: 0, zIndex: 1, width: '200px', backgroundColor: '#181436', color: 'white', height: '100vh', padding: '16px' }}>
                <div style={{ fontSize: '20px', marginBottom: '25px' }}> Company Logo</div>
                <SimpleTreeView onItemSelectionToggle={handleItemSelectionToggle} defaultSelectedItems={lastSelectedItem} selectedItems={lastSelectedItem}>

                    <div style={{ position: 'relative' }}>
                        <InsertChartIcon sx={{ fontSize: '25px', color: "white", position: 'absolute', top: 5, left: 2 }} />
                        <TreeItem itemId="dashboard" label="Dashboard" sx={{ backgroundColor: 'transparent', color: lastSelectedItem === 'dashboard' ? "hwb(23 16% 0%)" : "white" }} />
                    </div>

                    <div style={{ position: 'relative', }}>
                        <InsertChartIcon sx={{ fontSize: '25px', color: "white", position: 'absolute', top: 5, left: 2 }} />
                        <TreeItem itemId="orders" label="Orders" sx={{ backgroundColor: 'transparent', color: lastSelectedItem === 'orders' ? "hwb(23 16% 0%)" : "white" }} />
                    </div>

                    <div style={{ position: 'relative', }}>
                        <InsertChartIcon sx={{ fontSize: '25px', color: "white", position: 'absolute', top: 5, left: 2 }} />
                        <TreeItem itemId="menu" label="Menu" sx={{ backgroundColor: 'transparent', color: lastSelectedItem === 'menu' ? "hwb(23 16% 0%)" : "white" }} />
                    </div>



                    <TreeItem itemId="manage deliveries" label="Manage Deliveries">
                        <TreeItem itemId="manage drivers" label="Manage drivers" />
                    </TreeItem>



                    <TreeItem itemId="settings" label="Settings">
                        <TreeItem itemId="bank-details" label="Bank Details" />
                    </TreeItem>
                    <TreeItem itemId="ratings-and-reviews" label="Ratings & Reviews">
                        <TreeItem itemId="reviews" label="Reviews" />
                    </TreeItem>
                </SimpleTreeView>



                <AtomicButton
                    label="Logout"
                    style={{
                        position: 'absolute',
                        bottom: '35px',
                        zIndex: 1,
                        width: '100px',
                        backgroundColor: `${variables.activeFontOrange}`,
                        fontSize: '12px',
                        height: '30px'
                    }}
                    handleSubmit={triggerLogout}
                    endIcon={''}
                    startIcon={<LogoutIcon sx={{ width: '20px' }} />} />

            </div>

            <div style={{ width: '100%', marginLeft: '232px' }}>
                <header style={{ height: 50, backgroundColor: 'hwb(23 16% 0%)', width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex' }}>
                        <div style={{ color: 'white', margin: '0px 10px 0px 20px', fontSize: '24px', fontWeight: 600 }}>{TitleName(lastSelectedItem)}</div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <AccountCircleOutlinedIcon sx={{ fontSize: "20px", color: 'white', marginRight: '5px' }} />
                        <a style={{ color: 'white', marginRight: '10px' }}>{GreetingUser()}</a>
                        <a style={{ color: 'white', marginRight: '25px', fontWeight: 500, textTransform: 'capitalize' }}>{KitchenInfo?.firstName || 'Guest'}</a>
                    </div>
                </header>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {lastSelectedItem === 'dashboard' && <div>Dashboard</div>}
                    {lastSelectedItem === 'settings' && <div>Settings</div>}
                    {lastSelectedItem === 'bank-details' && <div>Bank Details</div>}
                    {lastSelectedItem === 'ratings-and-reviews' && <div>Ratings and Reviews</div>}
                    {lastSelectedItem === 'reviews' && <div>Reviews</div>}
                    {lastSelectedItem === 'menu' && <Product />}
                    {lastSelectedItem === 'manage deliveries' && <ManageDeliveries />}
                    {lastSelectedItem === 'manage drivers' && <ManageDrivers />}

                </div>

            </div>

        </div>
    )
}

export default Dashboard